import { render, staticRenderFns } from "./LocaleSetting.vue?vue&type=template&id=3b969d61&scoped=true"
import script from "./LocaleSetting.vue?vue&type=script&lang=js"
export * from "./LocaleSetting.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b969d61",
  null
  
)

export default component.exports